export default "/_assets/em-logo_white.055703a2.svg"